import { render, staticRenderFns } from "./graduates-detail.vue?vue&type=template&id=587eda70"
import script from "./graduates-detail.vue?vue&type=script&lang=js"
export * from "./graduates-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports